import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  Tooltip
} from "@mui/material";
import { SketchPicker } from "react-color";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import api, { API_BASE_URL } from "../../utils/api";

const PriorityLevelsPage = () => {
  const [priorityLevels, setPriorityLevels] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [form, setForm] = useState({ priority_value: "", display_name: "", color_code: "#000000" });
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    fetchPriorities();
  }, []);

  const fetchPriorities = async () => {
    const res = await api.get("/priority-levels");
    setPriorityLevels(res.data);
  };

  const handleOpen = (editData = null) => {
    setIsEditMode(!!editData);
    setForm(
      editData || {
        priority_value: "",
        display_name: "",
        color_code: "#000000"
      }
    );
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleSave = async () => {
    try {
      if (isEditMode) {
        await api.put(`/priority-levels/${form.priority_value}`, form);
      } else {
        await api.post("/priority-levels", form);
      }
      fetchPriorities();
      handleClose();
    } catch (err) {
      console.error("Error saving priority:", err);
    }
  };

  const handleDelete = async (priority_value) => {
    if (window.confirm("Are you sure you want to delete this priority?")) {
      await api.delete(`/priority-levels/${priority_value}`);
      fetchPriorities();
    }
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Priority Levels
      </Typography>

      <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpen()}>
        Add Priority
      </Button>

      <Grid container spacing={2} sx={{ mt: 2 }}>
        {priorityLevels.map((priority) => (
          <Grid item xs={12} sm={6} md={4} key={priority.priority_value}>
            <Card>
              <CardContent sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box>
                  <Typography variant="h6">{priority.display_name}</Typography>
                  <Typography variant="body2" color="textSecondary">
                    Value: {priority.priority_value}
                  </Typography>
                  <Chip
                    label={priority.color_code}
                    size="small"
                    sx={{
                      backgroundColor: priority.color_code,
                      color: "#fff",
                      mt: 1
                    }}
                  />
                </Box>
                <Box>
                  <Tooltip title="Edit">
                    <IconButton onClick={() => handleOpen(priority)}>
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton onClick={() => handleDelete(priority.priority_value)}>
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Add/Edit Dialog */}
      <Dialog open={openDialog} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>{isEditMode ? "Edit Priority" : "Add Priority"}</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Priority Value"
            value={form.priority_value}
            disabled={isEditMode}
            onChange={(e) => setForm({ ...form, priority_value: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="Display Name"
            value={form.display_name}
            onChange={(e) => setForm({ ...form, display_name: e.target.value })}
            sx={{ mb: 2 }}
          />
          <Typography variant="body2" sx={{ mb: 1 }}>
            Select Color:
          </Typography>
          <SketchPicker
            color={form.color_code}
            onChangeComplete={(color) => setForm({ ...form, color_code: color.hex })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PriorityLevelsPage;
